import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import * as commonServices from '../services/website.services';
import Swal from "sweetalert2";
import { SUBJECT_OPTIONS, SWAL_SETTINGS } from "../../../utils/Constants";
import { capitalizeFirstLetter, handleServerValidations } from "../../../utils/commonfunction";
import ShowSkyflowImage from "../../common/ShowSkyflowImage";
import { useSelector } from "react-redux";
import toHtml from 'html-react-parser';
import { Link } from "react-router-dom";

const ContactUs = () => {

    const [getGlobalData, setGlobalData] = useState({});
  const myGlobalData = useSelector((state) => state.globalData);

  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
      subject: ""
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .trim()
        .matches(/^[A-Za-z\s]+$/, "Name can only contain alphabets")
        .min(3, "Name must be at least 3 characters")
        .max(50, "Name cannot be more than 50 characters")
        .required("Name is required"),
    
      email: Yup.string()
        .trim()
        .email("Invalid email")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/,
          "Please enter a valid email address"
        )
        .required("Email is required"),
    
      subject: Yup.string()
        .trim()
        .required("Subject is required"),
    
      message: Yup.string()
        .trim()
        .min(10, "Message must be at least 10 characters")
        .max(1000, "Message cannot exceed 1000 characters")
        .required("Message is required"),
    }),    
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("message", values.message);
      formData.append("subject", values.subject);
      commonServices.saveContactUs(formData).then((response) => {
        if (response.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
          setTimeout(() => {
            resetForm();
          }, 1000);
        }
        else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    },
  });

  return (
    <main>
      <section className="banner-scetion-padding">
        <div className="container">
          <h1 className="heading-1 main-heading-2 text-center">babe, we’re here for you</h1>
        </div>
      </section>
      <section className="Conditions-item section-padding">
        <div className="container">
          <div className="contact-info-block">
            <div className="row">
              <div className="col-md-6">
                <div className="contact-info-actions">
                  <div className="contact-info-actions-row">
                    <figure>
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M32 24V29C32 29.7956 31.6839 30.5587 31.1213 31.1213C30.5587 31.6839 29.7956 32 29 32H24C22.5971 31.9985 21.2192 31.6282 20.0047 30.9261C18.7901 30.224 17.7815 29.2149 17.08 28C17.8339 27.9946 18.5852 27.9115 19.322 27.752C19.8832 28.4536 20.595 29.02 21.4048 29.4091C22.2146 29.7983 23.1016 30.0002 24 30H29C29.2652 30 29.5196 29.8946 29.7071 29.7071C29.8946 29.5195 30 29.2652 30 29V24C29.9998 23.1012 29.7972 22.214 29.4074 21.4042C29.0175 20.5944 28.4504 19.8827 27.748 19.322C27.9088 18.5853 27.9933 17.834 28 17.08C29.215 17.7814 30.2241 18.79 30.9262 20.0046C31.6282 21.2192 31.9986 22.597 32 24ZM25.977 17.651C26.0705 16.3626 25.8856 15.0692 25.4348 13.8586C24.9841 12.6481 24.278 11.5488 23.3646 10.6354C22.4512 9.72196 21.3518 9.01588 20.1413 8.56511C18.9308 8.11433 17.6374 7.92942 16.349 8.02295C14.0659 8.28368 11.9569 9.37013 10.4192 11.0777C8.88143 12.7853 8.02103 14.9961 8 17.294V22.334C8 24.866 9.507 26 11 26H16.7C18.9988 25.9802 21.211 25.1203 22.9198 23.5825C24.6286 22.0447 25.7159 19.935 25.977 17.651ZM21.95 12.051C22.6599 12.7625 23.2088 13.6181 23.5593 14.5601C23.9099 15.5021 24.054 16.5084 23.982 17.511C23.7686 19.2946 22.9105 20.9388 21.5693 22.1339C20.2282 23.329 18.4964 23.9927 16.7 24H11C10.072 24 10 22.725 10 22.334V17.294C10.0083 15.4983 10.6726 13.7677 11.8679 12.4276C13.0632 11.0876 14.707 10.2306 16.49 10.018C16.656 10.0059 16.822 9.99995 16.988 9.99995C17.9093 9.99909 18.8217 10.1798 19.6731 10.5317C20.5245 10.8836 21.2982 11.3999 21.95 12.051Z" fill="#F2B46D"></path>
                      </svg>
                    </figure>
                    <figcaption>
                      <h5 className="h5">Support Chat</h5>
                      <p className="m-0 body-2">Start a chat with our team and we’ll respond as quickly as possible. This option only available on <a href="#get-app" className="text-color-primary">mobile app</a>.</p>
                    </figcaption>
                  </div>
                  <div className="contact-info-actions-row">
                    <figure>
                      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" class="bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94" />
                      </svg>
                    </figure>
                    <figcaption>
                      <h5 className="h5">Frequently Asked Questions</h5>
                      <p className="m-0 body-2">Find quick answers to the most common questions about our services.</p>
                      <Link to="/frequentlyAskedQuestions"><button  type="submit" class="btn btn-purple mt-3">View</button></Link>
                    </figcaption>
                  </div>
                  <div className="contact-info-actions-row">
                    <figure>
                      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21H11C10.7348 21 10.4804 20.8946 10.2929 20.7071C10.1054 20.5196 10 20.2652 10 20C10 19.7348 10.1054 19.4804 10.2929 19.2929C10.4804 19.1054 10.7348 19 11 19H12C12.2652 19 12.5196 19.1054 12.7071 19.2929C12.8946 19.4804 13 19.7348 13 20ZM17 19H16C15.7348 19 15.4804 19.1054 15.2929 19.2929C15.1054 19.4804 15 19.7348 15 20C15 20.2652 15.1054 20.5196 15.2929 20.7071C15.4804 20.8946 15.7348 21 16 21H17C17.2652 21 17.5196 20.8946 17.7071 20.7071C17.8946 20.5196 18 20.2652 18 20C18 19.7348 17.8946 19.4804 17.7071 19.2929C17.5196 19.1054 17.2652 19 17 19ZM12 23H11C10.7348 23 10.4804 23.1054 10.2929 23.2929C10.1054 23.4804 10 23.7348 10 24C10 24.2652 10.1054 24.5196 10.2929 24.7071C10.4804 24.8946 10.7348 25 11 25H12C12.2652 25 12.5196 24.8946 12.7071 24.7071C12.8946 24.5196 13 24.2652 13 24C13 23.7348 12.8946 23.4804 12.7071 23.2929C12.5196 23.1054 12.2652 23 12 23ZM17 23H16C15.7348 23 15.4804 23.1054 15.2929 23.2929C15.1054 23.4804 15 23.7348 15 24C15 24.2652 15.1054 24.5196 15.2929 24.7071C15.4804 24.8946 15.7348 25 16 25H17C17.2652 25 17.5196 24.8946 17.7071 24.7071C17.8946 24.5196 18 24.2652 18 24C18 23.7348 17.8946 23.4804 17.7071 23.2929C17.5196 23.1054 17.2652 23 17 23ZM12 11H11C10.7348 11 10.4804 11.1054 10.2929 11.2929C10.1054 11.4804 10 11.7348 10 12C10 12.2652 10.1054 12.5196 10.2929 12.7071C10.4804 12.8946 10.7348 13 11 13H12C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11ZM17 11H16C15.7348 11 15.4804 11.1054 15.2929 11.2929C15.1054 11.4804 15 11.7348 15 12C15 12.2652 15.1054 12.5196 15.2929 12.7071C15.4804 12.8946 15.7348 13 16 13H17C17.2652 13 17.5196 12.8946 17.7071 12.7071C17.8946 12.5196 18 12.2652 18 12C18 11.7348 17.8946 11.4804 17.7071 11.2929C17.5196 11.1054 17.2652 11 17 11ZM12 15H11C10.7348 15 10.4804 15.1054 10.2929 15.2929C10.1054 15.4804 10 15.7348 10 16C10 16.2652 10.1054 16.5196 10.2929 16.7071C10.4804 16.8946 10.7348 17 11 17H12C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16C13 15.7348 12.8946 15.4804 12.7071 15.2929C12.5196 15.1054 12.2652 15 12 15ZM17 15H16C15.7348 15 15.4804 15.1054 15.2929 15.2929C15.1054 15.4804 15 15.7348 15 16C15 16.2652 15.1054 16.5196 15.2929 16.7071C15.4804 16.8946 15.7348 17 16 17H17C17.2652 17 17.5196 16.8946 17.7071 16.7071C17.8946 16.5196 18 16.2652 18 16C18 15.7348 17.8946 15.4804 17.7071 15.2929C17.5196 15.1054 17.2652 15 17 15ZM30 16V25C29.9984 26.3256 29.4711 27.5964 28.5338 28.5338C27.5964 29.4711 26.3256 29.9984 25 30H11C9.67441 29.9984 8.40356 29.4711 7.46622 28.5338C6.52888 27.5964 6.00159 26.3256 6 25V11C6.00159 9.67441 6.52888 8.40356 7.46622 7.46622C8.40356 6.52888 9.67441 6.00159 11 6H17C18.3256 6.00159 19.5964 6.52888 20.5338 7.46622C21.4711 8.40356 21.9984 9.67441 22 11H25C26.3256 11.0016 27.5964 11.5289 28.5338 12.4662C29.4711 13.4036 29.9984 14.6744 30 16ZM11 28H20V11C20 10.2044 19.6839 9.44129 19.1213 8.87868C18.5587 8.31607 17.7956 8 17 8H11C10.2044 8 9.44129 8.31607 8.87868 8.87868C8.31607 9.44129 8 10.2044 8 11V25C8 25.7956 8.31607 26.5587 8.87868 27.1213C9.44129 27.6839 10.2044 28 11 28ZM28 16C28 15.2044 27.6839 14.4413 27.1213 13.8787C26.5587 13.3161 25.7956 13 25 13H22V28H25C25.7956 28 26.5587 27.6839 27.1213 27.1213C27.6839 26.5587 28 25.7956 28 25V16ZM25 19C24.8022 19 24.6089 19.0586 24.4444 19.1685C24.28 19.2784 24.1518 19.4346 24.0761 19.6173C24.0004 19.8 23.9806 20.0011 24.0192 20.1951C24.0578 20.3891 24.153 20.5673 24.2929 20.7071C24.4327 20.847 24.6109 20.9422 24.8049 20.9808C24.9989 21.0194 25.2 20.9996 25.3827 20.9239C25.5654 20.8482 25.7216 20.72 25.8315 20.5556C25.9414 20.3911 26 20.1978 26 20C26 19.7348 25.8946 19.4804 25.7071 19.2929C25.5196 19.1054 25.2652 19 25 19ZM25 23C24.8022 23 24.6089 23.0586 24.4444 23.1685C24.28 23.2784 24.1518 23.4346 24.0761 23.6173C24.0004 23.8 23.9806 24.0011 24.0192 24.1951C24.0578 24.3891 24.153 24.5673 24.2929 24.7071C24.4327 24.847 24.6109 24.9422 24.8049 24.9808C24.9989 25.0194 25.2 24.9996 25.3827 24.9239C25.5654 24.8482 25.7216 24.72 25.8315 24.5556C25.9414 24.3911 26 24.1978 26 24C26 23.7348 25.8946 23.4804 25.7071 23.2929C25.5196 23.1054 25.2652 23 25 23ZM25 15C24.8022 15 24.6089 15.0586 24.4444 15.1685C24.28 15.2784 24.1518 15.4346 24.0761 15.6173C24.0004 15.8 23.9806 16.0011 24.0192 16.1951C24.0578 16.3891 24.153 16.5673 24.2929 16.7071C24.4327 16.847 24.6109 16.9422 24.8049 16.9808C24.9989 17.0194 25.2 16.9996 25.3827 16.9239C25.5654 16.8482 25.7216 16.72 25.8315 16.5556C25.9414 16.3911 26 16.1978 26 16C26 15.7348 25.8946 15.4804 25.7071 15.2929C25.5196 15.1054 25.2652 15 25 15Z" fill="#F2B46D"></path>
                      </svg>
                    </figure>
                    <figcaption>
                      <h5 className="h5">Connect with us</h5>
                      <p className="m-0 body-2">Follow us and stay updated on news, tips, and community stories.</p>
                      <div className="footer-item">
                        {getGlobalData?.social_media_details ?
                          <>
                            <ul className="d-flex gap-3 social-link cp mb-0 mt-3">
                              {getGlobalData?.social_media_details.map((item, index) => (
                                <li key={index}>
                                  <a href={item?.link} target="_blank" rel="noreferrer">
                                    {toHtml(item?.icon)}
                                  </a>
                                </li>
                              ))
                              }
                            </ul>
                          </> : <></>
                        }
                      </div>
                    </figcaption>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                
                <form className="contact-form" onSubmit={formik.handleSubmit}>
                  <figcaption>
                      <h5 className="h5 text-center pb-3">
                        {getGlobalData?.admin_email ? <>Contact us at <a className="text-color-primary" href="mailto:{getGlobalData?.admin_email}" title={getGlobalData?.admin_email}>{getGlobalData?.admin_email}</a> <br/> or fill out the form below</> : "Fill out the form below"}
                        
                        </h5>
                    </figcaption>
                  <div className="mb-3">
                    <label className="form-label subtitle-1">Name<span className="requirestar">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter name"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <div className="text-danger">{formik.errors.name}</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label subtitle-1">Email<span className="requirestar">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="text-danger">{formik.errors.email}</div>
                    )}
                  </div>
              
                  <div className="mb-3">
                    <label className="form-label subtitle-1">Subject<span className="requirestar">*</span></label>
                    <div className=" select-down-arrow">
                      <select
                        className="form-control"
                        name="subject"
                        value={formik.values.subject}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <option value="">Select subject</option>
                        {SUBJECT_OPTIONS && SUBJECT_OPTIONS.map((item, index) => (
                          <option key={index} value={item.value}>
                            {capitalizeFirstLetter(item.label)}
                          </option>
                        ))}
                      </select>
                    </div>
                    {formik.touched.subject && formik.errors.subject && (
                      <div className="text-danger">{formik.errors.subject}</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label subtitle-1">Message</label>
                    <textarea
                      className="form-control"
                      placeholder="Write your message"
                      name="message"
                      value={formik.values.message}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.message && formik.errors.message && (
                      <div className="text-danger">{formik.errors.message}</div>
                    )}
                  </div>
                  <button type="submit" className="btn btn-purple">Submit</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ContactUs;
